import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import ImportMapping from './ImportMapping/ImportMapping';
import { Button } from './ui/button';
import { FC } from 'react';

interface Props {
  onBackToList: () => void;
}

const ClientCsvUpload: FC<Props> = ({ onBackToList }) => {
  return (
    <Card className="w-full">
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle className="text-2xl text-tax-deepBlue">
            Bulk Import Clients
          </CardTitle>
          <CardDescription>
            Upload a CSV file with multiple clients to add them all at once
          </CardDescription>
        </div>
        <Button variant="outline" onClick={onBackToList}>
          Back to List
        </Button>
      </CardHeader>
      <CardContent>
        <ImportMapping onBackToList={onBackToList} />
      </CardContent>
    </Card>
  );
};

export default ClientCsvUpload;
